import type { ReactNode } from "react";

import { Center } from "@chakra-ui/react";

import { NavBar } from "@app/navigation/ui/nav-bar.tsx";
import { $session } from "@entities/session";
import { PageTemplate } from "@shared/ui/templates/page-template";
import { HelpBox } from "@widgets/profile-avatar/ui/help-box.tsx";

type Props = {
  children: ReactNode;
};

export const Template = ({ children }: Props) => {
  if ($session.getState().accessToken !== undefined) {
    return (
      <PageTemplate
        navigationSlot={<NavBar />}
        profileSlot={<HelpBox email="segunadebayo@mail.com" />}
      >
        <Center flexGrow={1}>{children}</Center>
      </PageTemplate>
    );
  }

  return (
    <PageTemplate profileSlot={<HelpBox email="segunadebayo@mail.com" />}>
      <Center flexGrow={1}>{children}</Center>
    </PageTemplate>
  );
};
